import React from 'react';
import { Check, ChevronRight } from 'lucide-react';
import { ProductSelector } from '../components/Builder/ProductSelector';
import { TemplateSelector } from '../components/Builder/TemplateSelector';
import { CheckoutEditor } from '../components/Builder/CheckoutEditor';
import { PublishCheckout } from '../components/Builder/PublishCheckout';

const steps = [
  { id: 'product', title: 'Select Product' },
  { id: 'template', title: 'Choose Template' },
  { id: 'edit', title: 'Customize' },
  { id: 'publish', title: 'Publish' },
];

export const CheckoutBuilder = () => {
  const [currentStep, setCurrentStep] = React.useState('product');
  const [completedSteps, setCompletedSteps] = React.useState<string[]>([]);

  const handleNext = (step: string) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setCurrentStep(step);
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 'product':
        return <ProductSelector onNext={() => handleNext('template')} />;
      case 'template':
        return <TemplateSelector onNext={() => handleNext('edit')} onBack={() => setCurrentStep('product')} />;
      case 'edit':
        return <CheckoutEditor onNext={() => handleNext('publish')} onBack={() => setCurrentStep('template')} />;
      case 'publish':
        return <PublishCheckout onBack={() => setCurrentStep('edit')} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-8 max-w-6xl mx-auto">
      {/* Timeline Steps */}
      <div className="mb-8">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="flex items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    completedSteps.includes(step.id)
                      ? 'bg-[#1E293B] text-white'
                      : currentStep === step.id
                      ? 'bg-[#1E293B] text-white'
                      : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  {completedSteps.includes(step.id) ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <span>{index + 1}</span>
                  )}
                </div>
                <span
                  className={`ml-3 font-medium ${
                    currentStep === step.id ? 'text-[#1E293B]' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className="flex-1 mx-4">
                  <div
                    className={`h-0.5 ${
                      completedSteps.includes(step.id)
                        ? 'bg-[#1E293B]'
                        : 'bg-gray-200'
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Step Content */}
      <div className="bg-white rounded-2xl shadow-sm p-6">
        {renderStepContent()}
      </div>
    </div>
  );
};